import React from "react";
import ApplicationDashboardPage from "../../recruitment-shared/pages/ApplicationDashboardPage";

export default function FacultyApplicationDashboard() {
  return <ApplicationDashboardPage type="FACULTY" />;
}
